import classNames from 'classnames';
import { FC } from 'react';

import { popupItemStyles } from '@gem/ui-kit';

import { AvatarTypes } from 'APP/components/Avatar/Avatar';
import { PopupInfoCard } from 'APP/components/PopupInfoCard/PopupInfoCard';
import { VerifiedBadge } from 'APP/components/VerifiedBadge/VerifiedBadge';

import { CheckboxRow } from '../CheckboxRow/CheckboxRow';
import { ISharedDataViewItemData } from '../ShareDataView.types';
import { useSharedDataContactItemPresenter } from './SharedDataContactItem.presenter';

interface IContactItemProps {
  data: ISharedDataViewItemData;
  isSelected: boolean;
  withCheckbox: boolean;
  onClick(): void;
  isDisabled?: boolean;
}

export const SharedDataContactItem: FC<IContactItemProps> = (props) => {
  const { data, onClick, isSelected, withCheckbox, isDisabled } = props;

  const { userOnlineStatusText } = useSharedDataContactItemPresenter(data);

  const avatar = (
    <PopupInfoCard
      type={AvatarTypes.Round_10}
      avatarTitle={data.avatarTitle}
      avatarUrl={data.avatarUrl}
      avatarBackgroundColorIndex={data.avatarColorIndex}
      title={data.avatarTitle}
      subtitle={userOnlineStatusText}
      badge={data.verified && <VerifiedBadge />}
    />
  );

  if (withCheckbox) {
    return (
      <CheckboxRow
        onClick={onClick}
        isSelected={isSelected}
        isDisabled={isDisabled}
      >
        {avatar}
      </CheckboxRow>
    );
  }

  return (
    <button
      onClick={onClick}
      className={classNames(popupItemStyles.container, {
        [popupItemStyles.interactive]: !isDisabled,
      })}
    >
      {avatar}
    </button>
  );
};
